import { Toaster } from 'sonner';
import CustomCursor from '@/components/CustomCursor';
import CodeRain from '@/components/CodeRain';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import WhatIsSection from '@/components/WhatIsSection';
import CulturalShiftSection from '@/components/CulturalShiftSection';
import SpaceSection from '@/components/SpaceSection';
import TeamSection from '@/components/TeamSection';
import ArtistsSection from '@/components/ArtistsSection';
import '@/App.css';

function App() {
  return (
    <div className="bg-[#050505] min-h-screen text-[#F5F5F5]">
      <CustomCursor />
      <CodeRain />
      <Header />
      <main>
        <HeroSection />
        <ArtistsSection />
        <WhatIsSection />
        <CulturalShiftSection />
        <SpaceSection />
        <TeamSection />
      </main>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#111111',
            border: '1px solid #333333',
            color: '#F5F5F5',
            borderRadius: 0,
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '12px',
          },
        }}
      />
    </div>
  );
}

export default App;
